/**
 * Fractional Indexing ユーティリティ
 * リストの任意の位置に要素を挿入するための順序値を生成
 */

import type { SetItem } from '../types'

export class FractionalIndex {
  /**
   * 2つの値の間の新しい値を生成
   */
  static between(a: number | null, b: number | null): number {
    if (a === null && b === null) return 1.0
    if (a === null && b !== null) return b / 2
    if (b === null && a !== null) return a + 1.0
    return ((a ?? 0) + (b ?? 0)) / 2
  }

  /**
   * 配列の指定位置に挿入するための新しいorder値を計算
   */
  static getOrderForPosition(items: SetItem[], position: number): number {
    const sorted = [...items].sort((a, b) => a.order - b.order)
    
    if (position <= 0) {
      return FractionalIndex.between(null, sorted[0]?.order ?? null)
    }
    
    if (position >= sorted.length) {
      return FractionalIndex.between(sorted[sorted.length - 1]?.order ?? null, null)
    }
    
    return FractionalIndex.between(
      sorted[position - 1]?.order ?? null,
      sorted[position]?.order ?? null
    )
  }
}